import { createContext, useContext } from 'react';
import { DataCollection } from './types';

export const DataContext = createContext<{
	loadPage: (pathname: string, search: string) => Promise<DataCollection | undefined>;
	data: Partial<DataCollection>;
}>(null!);

export const useData = () => useContext(DataContext);
